export const CLOSE_DELAY = 250;
